"use client"

import { EvaluationLabeledLifecycle } from "@/components/evaluation-dashboard/evaluation-stage-pipeline"
import { evaluationLifecycleStagePath } from "@/lib/evaluation-routes"
import { useProduct } from "@/contexts/product-context"
import type { EvaluationTerm } from "@/lib/mock/evaluation-dashboard"

interface OperationsLifecycleSectionProps {
  term: EvaluationTerm
  density?: "default" | "compact"
}

export function OperationsLifecycleSection({
  term,
  density = "default",
}: OperationsLifecycleSectionProps) {
  const { product } = useProduct()

  return (
    <EvaluationLabeledLifecycle
      counts={term.counts}
      courseOfferings={term.courseOfferings}
      stageHref={stageId => evaluationLifecycleStagePath(product, term.id, stageId)}
      density={density}
    />
  )
}
